import styled from 'styled-components';
import { MapContainer } from "react-leaflet";

export const Wrapper = styled.div`
  padding: 1rem;
  
  h1 {
    font-size: 24px;
  }
`

export const DetachedWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Overlay = styled.div`
  background: var(--black);
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ErrorMessage = styled.h1`
  font-size: 2rem;
  text-align: center;
  max-width: 70%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background: var(--black-200);

  @media (max-width: 1000px) {
    flex-direction: column !important;
    overflow-y: scroll !important;
    height: 100% !important;
    width: 100% !important;
  }
`

export const OccurrenceInfoContainer = styled.div`
  overflow-y: scroll;
  max-height: 100%;
  width: 50%;
  flex-grow: 1;
  border-right: 1px solid var(--primary);

  @media (max-width: 1000px) {
    width: 100% !important;
    border: none !important;
    height: fit-content;
    border-bottom: 1px solid var(--primary) !important;
  }
`

export const StyledMapContainer = styled.div`
  width: 50%;
  max-height: 100%;
  flex-grow: 1;

  @media (max-width: 1000px) {
    width: 100% !important;
    height: 50%;
  }

`
export const StyledMap = styled(MapContainer)`
  width: 100%;
  height: 100%;

  @media (max-width: 1000px) {
    width: 100%;
    height: 50rem !important;
  }
`